import { render, staticRenderFns } from "./SectionAttivita.vue?vue&type=template&id=e71fc450&scoped=true&"
import script from "./SectionAttivita.vue?vue&type=script&lang=js&"
export * from "./SectionAttivita.vue?vue&type=script&lang=js&"
import style0 from "./SectionAttivita.vue?vue&type=style&index=0&id=e71fc450&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71fc450",
  null
  
)

export default component.exports